import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="border-t border-gray-300 py-12 mt-12 bg-gray-50" data-id="element-138">
      <div className="container mx-auto px-4" data-id="element-139">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12" data-id="element-140">
          <div className="border border-dashed border-gray-300 p-4 bg-white" data-id="element-141">
            <h3 className="font-bold mb-4" data-id="element-142">De Maekerij</h3>
            <p className="text-sm text-gray-600" data-id="element-143">
              Een creatieve organisatie voor workshops, netwerkbijeenkomsten en
              koffie onder één dak.
            </p>
          </div>

          <div className="border border-dashed border-gray-300 p-4 bg-white" data-id="element-144">
            <h3 className="font-bold mb-4" data-id="element-145">Navigatie</h3>
            <ul className="space-y-2 text-sm" data-id="element-146">
              <li data-id="element-147">
                <Link to="/workshops" className="hover:underline text-gray-600 hover:text-gray-900" data-id="element-148">
                  Kalender
                </Link>
              </li>
              <li data-id="element-149">
                <Link to="/workshop-info" className="hover:underline text-gray-600 hover:text-gray-900" data-id="element-150">
                  Workshops
                </Link>
              </li>
              <li data-id="element-151">
                <Link to="/maekerscafés" className="hover:underline text-gray-600 hover:text-gray-900" data-id="element-152">
                  Maekerscafés
                </Link>
              </li>
              <li data-id="element-153">
                <Link to="/koffiebar" className="hover:underline text-gray-600 hover:text-gray-900" data-id="element-154">
                  Koffiebar
                </Link>
              </li>
              <li data-id="element-155">
                <Link to="/locatie-huren" className="hover:underline text-gray-600 hover:text-gray-900" data-id="element-156">
                  Locatie huren
                </Link>
              </li>
              <li data-id="element-157">
                <Link to="/cadeaubonnen" className="hover:underline text-gray-600 hover:text-gray-900" data-id="element-158">
                  Cadeaubonnen
                </Link>
              </li>
            </ul>
          </div>

          <div className="border border-dashed border-gray-300 p-4 bg-white" data-id="element-159">
            <h3 className="font-bold mb-4" data-id="element-160">Contact</h3>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-161">
              <li data-id="element-162">Louis Melsensstraat 17</li>
              <li data-id="element-163">3000 Leuven</li>
              <li data-id="element-164">+32 473 52 48 85</li>
              <li data-id="element-165">
                <a href="mailto:welkom@demaekerij.be" className="hover:underline" data-id="element-166">
                  welkom@demaekerij.be
                </a>
              </li>
            </ul>
          </div>

          <div className="border border-dashed border-gray-300 p-4 bg-white" data-id="element-167">
            <h3 className="font-bold mb-4" data-id="element-168">Nieuwsbrief</h3>
            <div className="flex flex-col space-y-2" data-id="element-169">
              <input type="email" placeholder="Jouw emailadres" className="border border-gray-300 p-2 text-sm w-full rounded focus:outline-none focus:ring-2 focus:ring-gray-300" data-id="element-170" />
              <button className="bg-gray-800 text-white px-4 py-2 text-sm rounded hover:bg-gray-700 transition-colors" data-id="element-171">
                Aanmelden
              </button>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-172">
          <div className="mb-4 md:mb-0" data-id="element-173">
            © {new Date().getFullYear()} De Maekerij. Alle rechten
            voorbehouden.
          </div>
          <div className="flex flex-wrap justify-center gap-4 md:gap-6" data-id="element-174">
            <Link to="/algemene-voorwaarden" className="hover:text-gray-900 hover:underline" data-id="element-175">
              Algemene voorwaarden
            </Link>
            <Link to="/privacybeleid" className="hover:text-gray-900 hover:underline" data-id="element-176">
              Privacybeleid
            </Link>
            <Link to="/cookiebeleid" className="hover:text-gray-900 hover:underline" data-id="element-177">
              Cookiebeleid
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}